import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ type: "spring", stiffness: 90, damping: 20, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Kinetic masked line-by-line reveal (runs on mount).
export const KineticHeadline = ({ lines = [], className = "", lineClassName = "" }) => (
  <h1 className={className} data-testid="hero-headline">
    {lines.map((line, i) => {
      let content = line;
      if (typeof line === "object" && line !== null && Array.isArray(line.words)) {
        content = line.words.map((w, wi) => (
          <span key={wi}>
            {w.text}{" "}
          </span>
        ));
      }
      return (
        <span key={i} className="block overflow-hidden pb-[0.12em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.9,
              ease: [0.16, 1, 0.3, 1],
              delay: 0.25 + i * 0.14,
            }}
          >
            {content}
          </motion.span>
        </span>
      );
    })}
  </h1>
);

export default Reveal;
